import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import React from "react";
import Home from "./page/HomeSpeaker.js";
import Test from "./page/Test.js";
import Result from "./page/Result.js";
import Privacy from "./page/Privacy.js";
import "./style/global.css";
import InstallPrompt from "./component/InstallPrompt";

export default function App() {
  return (
    <Router>
      <InstallPrompt />
      <Switch>
        <Route path="/privacy">
          <Privacy />
        </Route>
        <Route path="/test">
          <Test />
        </Route>
        <Route path="/result/:id">
          <div id="top-container" className="bg">
            <Result />
          </div>
        </Route>
        <Route path="/">
          <div id="top-container">
            <Home />
          </div>
        </Route>
      </Switch>
    </Router>
  );
}


